
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agreements/cookie",
      function () {
        return require("private-next-pages/agreements/cookie.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agreements/cookie"])
      });
    }
  